/**
 * Bulk / by-id trees never carry session-only client data (historical_data from
 * history endpoints; meteorological_sources names from by-id / includeStations
 * enrichment). When replacing an already-hydrated tree from an
 * includeStations=false bulk payload, copy those from the previous tree so
 * graphs and Update Field meteo UI do not blank.
 *
 * Pure helper — unit-tested via node:test.
 */
function preserveDistributionClientData(previous, incoming) {
  if (!previous?.farming_units || !incoming?.farming_units) {
    return incoming;
  }
  const farming_units = { ...incoming.farming_units };
  for (const fuId of Object.keys(farming_units)) {
    const prevFu = previous.farming_units[fuId];
    const nextFu = farming_units[fuId];
    if (!prevFu || !nextFu) {
      continue;
    }
    const mergedFu = { ...nextFu };
    if (prevFu.historical_data) {
      mergedFu.historical_data = prevFu.historical_data;
    }
    if (prevFu.fields && nextFu.fields) {
      const fields = { ...nextFu.fields };
      for (const fieldId of Object.keys(fields)) {
        const prevField = prevFu.fields[fieldId];
        const nextField = fields[fieldId];
        if (!prevField || !nextField) {
          continue;
        }
        let mergedField = nextField;
        if (prevField.historical_data) {
          mergedField = {
            ...mergedField,
            historical_data: prevField.historical_data,
          };
        }
        const prevSources = prevField.geo_data?.meteorological_sources;
        if (Array.isArray(prevSources) && prevSources.length > 0) {
          mergedField = {
            ...mergedField,
            geo_data: {
              ...(mergedField.geo_data || {}),
              meteorological_sources: prevSources,
            },
          };
        }
        fields[fieldId] = mergedField;
      }
      mergedFu.fields = fields;
    }
    farming_units[fuId] = mergedFu;
  }
  return { ...incoming, farming_units };
}

module.exports = { preserveDistributionClientData };
